module.exports = "\n  <router-outlet></router-outlet>\n"